import {
  apiGetCompanyId,
  apiSaveCompanyData,
  apiGetQBOAuthUri,
  apiCreatePandaDoc,
  apiPostEmail,
  apiGetGPTCategorySelection,
  apiGetGPTNoteGeneration,
  apiGetGPTSearchRate,
  apiGetGPTSearchCompany,
  apiGetGPTSearchReport,
  apiGetCompanyBalanceSheet,
  apiGetCompanyProfitLoss,
  apiGetProjectList,
  apiGetProjectData,
  apiSaveProjectData,
  apiDeleteProjectData
} from "../services/api.js/backend";
import BalanceSheet from "../models/valuation/BalanceSheet";
import FinancialAccount from "../models/FinancialAccount";
import ProfitAndLoss from "../models/ProfitAndLoss";
import { selectCategory } from "../store/modules/category/actions";
import { store } from "../store";
import _ from "lodash";

export default class FinancialHandler {
  static async fetchCompanyId(payload) {
    try {
      const response = await apiGetCompanyId(payload);
      return response;
    } catch (error) {
      throw error
    }
  }

  static async saveCompanyData(payload) {
    try {
      const response = await apiSaveCompanyData(payload);
      return response;
    } catch (error) {
      throw error
    }
  }

  static async fetchQBOAuthUri(payload) {
    try {
      const response = await apiGetQBOAuthUri(payload);
      return response;
    } catch (error) {
      throw error
    }
  }

  static async createDashboardReport(payload) {
    return apiCreatePandaDoc(payload)
  }

  static async postEmail(email, analystName, link) {
    const payload = {
      to: `${email}`,
      subject: 'Please Provide Your Company Financial Data for Valuation',
      message:
        `<html lang="en">
          <head>
            <meta charset="UTF-8">
            <title>Please Provide Your Company Financial Data to Business Valuation Advisors, Inc.</title>
          </head>
          <body style="font-family: Arial, Helvetica, sans-serif; margin:0; padding:0; background:#f9f9f9;">
            <table width="100%" cellpadding="0" cellspacing="0" style="background:#f9f9f9; padding:30px 0;">
              <tr>
                <td align="center">
                  <table width="100%" cellpadding="0" cellspacing="0" style="max-width:500px; background:#fff; border-radius:8px; box-shadow:0 2px 6px rgba(0,0,0,0.06); padding:30px;">
                    <tr>
                      <td>
                        <h2 style="color:#222; font-size:22px; margin-bottom:18px; font-weight:normal;">
                          Please Provide Your Company Financial Data for Valuation
                        </h2>
                        <p style="color:#444; font-size:16px; margin-bottom:28px;">
                          Hello,<br><br>
                          This is ${analystName}, your business valuation advisor. Please click the button below to securely provide your company’s financial data.<br><br>
                          Thank you for your cooperation.
                        </p>
                        <table cellpadding="0" cellspacing="0" style="margin:auto;">
                          <tr>
                            <td align="center">
                              <a href="${link}" target="_blank"
                                style="background:#5e6ad2; color:#fff; text-decoration:none; padding:14px 34px; border-radius:5px; font-size:16px; display:inline-block;">
                                Provide Financial Data
                              </a>
                            </td>
                          </tr>
                        </table>
                        <p style="color:#bbb; font-size:13px; margin-top:38px;">
                          If you have any questions, feel free to reply to this email.<br>
                          &copy; Business Valuation Advisors, Inc.
                        </p>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </body>
        </html>`
    }
    
    try {
      const response = await apiPostEmail(payload);
      return response;
    } catch (error) {
      throw error
    }
  }

  static async fetchGPTCategorySelection(name, type) {
    try {
      let categoryObjectArray, response, resultArray, count = 0;
      
      //get available category name & value object array
      if(type === "Fixed Assets" || type === "Current Assets")
        categoryObjectArray = FinancialAccount.getAssetsCategoryOptions().filter((category) => category.group === type);
      else if(type === "Long Term Liability" || type === "Current Liabilities")
        categoryObjectArray = FinancialAccount.getLiabilitiesCategoryOptions().filter((category) => category.group === type);
      else if(type === "Equity") categoryObjectArray = FinancialAccount.getEquitiesCategoryOptions();
      else categoryObjectArray = ProfitAndLoss.getCategoriesOptions(type);

      if(type === "expenses") categoryObjectArray = categoryObjectArray.filter((category) => category.name !== "Other");
        //filter "Other" selection from P & L Expenses to improve accuracy

      //generate user question
      let payload = "What does '" + name + "' belong to among '" + categoryObjectArray.map(obj => obj.name).join("', '")
        + "'?";
      do {
        //That's because we sometimes receive a wrong formatted answer. We loop until it receives a valid answer.
        count++;
        response = await apiGetGPTCategorySelection(payload);
        resultArray = categoryObjectArray.filter(obj => obj.name === response);
        if(count > 5) {   //exit for loop when it is looped more than 5 times
          resultArray = categoryObjectArray;
          break;
        }
      } while (resultArray.length === 0);
      return resultArray[0].value;
    } catch (error) {
      throw error
    }
  }

  static async fetchGPTHDENoteGeneration(labelTitle, years, revenue, EBITDA, matrix, total, other) {
    try {
      const len = matrix.length;

      //generate user question
      let payload =
        "These are the company's basic data." +
        "\nfinancial years: " + years.join(", ") +
        "\nsales revenue: " + revenue.map(obj => obj.value.toFixed(2) + "$").join(", ") +
        "\nEBITDA as defined: " + EBITDA.map(obj => obj.value.toFixed(2) + "$").join(", ") +
        "\nThese are the company's " + labelTitle + " data.";
      
      for(let i = 0; i < len - 1; i++) {
        payload += "\n" + matrix[i].name + ": " + matrix[i].series?.map(obj => Number(obj.value).toFixed(2) + "$").join(", ");
      }
      
      payload +=
        "\nTotal " + labelTitle + ": " + total.map(obj => obj.value.toFixed(2) + "$").join(", ");

      if(labelTitle === "Ownership Salary") payload +=
        "\nSocial Security Taxes" + ": " + other.socialSecirutyTax.map(obj => obj.value.toFixed(2) + "$").join(", ") +
        "\nMedicare Taxes" + ": " + other.medicareTax.map(obj => obj.value.toFixed(2) + "$").join(", ") +
        "\nTotal Ownership Salary and Payroll Taxes" + ": " + other.grandTotal.map(obj => obj.value.toFixed(2) + "$").join(", ") +
        "\nThe goal of this section is to calculate add all the direct payroll compensation to the business owners or related parties. You adjust for payroll taxes associated with owner wages, which increases the benefit to the Owners Discretionary Earnings. Include a year-over-year comparison and other relevant findings if available.";
      else if(labelTitle === "Owner Retirement Contributions") payload +=
        "\nIn this section, we are including direct retirement benefits for any owner or related party. Retirement contributions for business owners or related parties are added back as part of Owners Discretionary Earnings normalization.";
      else if(labelTitle === "Owner Health & Insurance Benefits") payload +=
        "\nIn this section, we are including direct Owner Health & Insurance Benefits for any owner or related party. Health and insurance benefits paid on behalf of business owners or related parties are added back to normalize the earnings stream.";
      else if(labelTitle === "Non-Operating Expenses") payload +=
        "\nIn this section, we are adding non-operating expenses. We identify and add back expenses that are not essential to the operation of the business and which primarily benefit the owner or related parties. We assume that these expenses are discretionary and directly benefit the business owners or related parties. These expenses may include personal or lifestyle-related expenditures that are not necessary for a typical buyer to operate the business and thus should be normalized to reflect true economic benefit.";
      else if(labelTitle === "Non-Recurring Expenses") payload +=
        "\nIn this section, we identify and add back legitimate but unusual or infrequent expenses that are not expected to recur in the normal course of business operations. These are abnormal, one-time events that distort the earnings picture in the specific year they occurred. The goal is to normalize earnings to reflect what a typical buyer can reasonably expect going forward, removing financial distortions caused by unusual or isolated events.";
      else if(labelTitle === "Over & Under Payment Adjustments") payload +=
        "\nWe identify adjustments to earnings based on overstated or understated expenses. The objective is to normalize the earnings to reflect an independent buyer’s likely cost structure. This could include a capitalization adjustment to the financial statement for an expense that should have been capitalized or vice versa.";

      payload += "\nPlease analyze " + labelTitle + " based on the data.";

      console.log(payload)
      const response = await apiGetGPTNoteGeneration(payload);
      return response;
    } catch (error) {
      throw error
    }
  }

  static async fetchGPTSDENoteGeneration(labelTitle, years, revenue, EBITDA, matrix, totalAdj, EBITDAAdj) {
    try {
      const len = matrix.length;

      //generate user question
      let payload =
        "These are the company's basic data." +
        "\nfinancial years: " + years.join(", ") +
        "\nsales revenue: " + revenue.map(obj => obj.value.toFixed(2) + "$").join(", ") +
        "\nEBITDA as defined: " + EBITDA.map(obj => obj.value.toFixed(2) + "$").join(", ") +
        "\nThese are the company's " +
        (labelTitle === "Owner Salary" ? "Ownership Salaries" : "\"EBITDA " + labelTitle + " Adjusted\"") +
        " data.";
        
      for(let i = 0; i < len - 1; i++) {
        payload += "\n" + matrix[i].name + ": " + matrix[i].series?.map(obj => Number(obj.value).toFixed(2) + "$").join(", ");
      }
      
      payload +=
        "\nTotal " + labelTitle + " Adjusted: " + totalAdj.map(obj => obj.value.toFixed(2) + "$").join(", ") +
        (labelTitle === "Owner Salary" ? "\nDiscretionary Owner Earnings: " : "\nEBITDA " + labelTitle + " Adjusted: ") +
        EBITDAAdj.map(obj => obj.value.toFixed(2) + "$").join(", ");
      
      if(labelTitle === "Ownership Salary") payload +=
        "\nYou adjust for payroll taxes associated with owner wages. You report total compensation in a clear ownership compensation schedule (include year-over-year comparison if available).";
      else if(labelTitle === "Management") payload +=
        "\nThe purpose of this exercise is for the owners to present a normalized and sustainable earnings figure by adjusting reported EBITDA for owner discretion expenses, one-time items, non-recurring items, and accounting inconsistencies.";
      else if(labelTitle === "Diligence") payload +=
        "\nThis version of EBITDA reflects normalized operating performance after applying third-party diligence-driven adjustments. Adjustments may be made to the accounting treatment or methodology, or market-based adjustments may be made to related-party transactions or non-arm's-length pricing.";
      else if(labelTitle === "Pro Forma") payload +=
        "\nThis version of EBITDA adjustments reflects the estimated, normalized earnings of the business post-deal, assuming certain structural changes, cost savings, or revenue adjustments that are not fully captured in historical results but are likely to occur with a new owner.";
      
      payload += "\nPlease analyze this situation with a focus on \"" + labelTitle + " Adjusted\" based on the data.";

      const response = await apiGetGPTNoteGeneration(payload);
      return response;
    } catch (error) {
      throw error
    }
  }

  static async fetchGPTForecastNoteGeneration(type, method, years, array, forecastYear, forecastedValue, longTermValue) {
    try {
      //generate user question
      let payload = type === "RevenueForecast"
        ? "We are reviewing the historical sales (if any) and then are forecasting the next year’s revenue. This revenue forecast is important because it will align our forecast for additional working capital, capital expenditures, and depreciation."
        : "We are reviewing the historical Discretionary Owner Earnings (if any) and then are forecasting the next year’s Discretionary Owner Earnings. Discretionary Owner Earnings encompass all the benefits of owning the business. These include both adjusted EBITDA items along with salaries to the owners and related parties.";
        
      payload +=
        "\nfinancial years: " + years.join(", ") +
        "\n" + (type === "RevenueForecast" ? "sales revenue" : "discretionary owner earnings") + ": " + array.map(obj => obj.value.toFixed(2) + "$").join(", ") +
        "\nThe forecasted " + (type === "RevenueForecast" ? "sales revenue" : "discretionary owner earnings") +
          " for " + forecastYear + " is " + Number(forecastedValue).toFixed(2) + "$. " + method + " forecast method is used for that." +
        "\nLong-Term forecasted " + (type === "RevenueForecast" ? "sales revenue" : "discretionary owner earnings") +" is " + Number(longTermValue).toFixed(2) + "$." +
        "\nPlease analyze this situation.";

      const response = await apiGetGPTNoteGeneration(payload);
      return response;
    } catch (error) {
      throw error
    }
  }

  static async fetchGPTSimpleNoteGeneration(payload) {
    try {
      const response = await apiGetGPTNoteGeneration(payload);
      return response;
    } catch (error) {
      throw error
    }
  }

  static async fetchGPTCapitalizationNoteGeneration(preTaxRate, afterTaxRate) {
    try {
      //generate user question
      let payload =
        "Here are the definitions to use in your notes on capitalization rate." + 
        "\nRisk-Free Rate: the rate of return available in the market on an investment free of default risk." +
        "\nEquity Risk Premium: rate of return added to a risk-free rate to reflect the additional risk of equity instruments over risk-free instruments.(a component of the cost of equity capital or equity discount rate)" + 
        "\nSize Premium: In business valuation, the size premium is an additional risk premium applied to the cost of capital for smaller companies, reflecting the higher risk associated with investing in them compared to larger companies." +
        "\nIndustry Risk: the industry risk premium is the extra return, beyond the risk-free rate, that investors expect to receive for investing in a specific industry due to the unique risks associated with that industry." +
        "\nCountry Risk: is added to the cost of capital when valuing companies operating in countries with higher perceived risk. " +
        "\nRisk Premium for Company Specific Risks: unique risks associated with the particular company." +
        "\nHere are the company's risk data." +
        "\nRisk free rate: " + Number(afterTaxRate.riskFreeRate).toFixed(2) + "%" +
        "\nEquity risk premium: " + Number(afterTaxRate.equityRiskPremium).toFixed(2) + "%" +
        "\nSize premium: " + Number(afterTaxRate.sizePremium).toFixed(2) + "%" +
        "\nIndustry risk: " + Number(afterTaxRate.industryRisk).toFixed(2) + "%" +
        "\nCountry risk: " + Number(afterTaxRate.countryRisk).toFixed(2) + "%" +
        "\nRisk premium for company specific risks: " + Number(afterTaxRate.riskPremiumCompanySpecificRisks).toFixed(2) + "%" +
        "\nThese are the company's capitalization rate data." +
        "\nLong-term sustainable growth rate: " + Number(afterTaxRate.longTermSustainableGrowthRate).toFixed(2) + "%" +
        "\nAfter-tax net cash flow discount rate: " + Number(afterTaxRate.afterTaxNetCashFlowDiscountRate).toFixed(2) + "%" +
        "\nAfter-tax net cash flow capitalization rate: " + Number(afterTaxRate.afterTaxNetCashFlowCapitalizationRate).toFixed(2) + "%" +
        "\nAfter-tax to pre-tax ratio: " + Number(preTaxRate.ratioAfterToPreTax).toFixed(2) + "%" +
        "\nPre-tax net cash flow discount rate: " + Number(preTaxRate.preTaxNetCashFlowDiscountRate).toFixed(2) + "%" +
        "\nPre-tax net cash flow capitalization rate: " + Number(preTaxRate.preTaxNetCashFlowCapitalizationRate).toFixed(2) + "%" +
        "\nThe calculation logic is like this. Adding the risk premiums we generate our After-Tax Net Cash Flow Discount Rate. We then subtract the Long-Term Sustainable Growth Rate which will derive our After-tax Net Cash Flow Capitalization Rate." +
        "\nPlease analyze this company's capitalization rate situation."

      const response = await apiGetGPTNoteGeneration(payload);
      return response;
    } catch (error) {
      throw error
    }
  }

  static async fetchGPTBookValueNoteGeneration(assets, liabilities, equity) {
    try {
      //generate user question
      let payload =
        "These are the company's total asset data. This Adjusted Book Value Model is a valuation tool used by analysts to assess the real-world economic value of a company’s balance sheet by modifying traditional accounting figures. Adjust for non-operating, overstated, or understated assets or liabilities, Optionally consider liquidation value if the business were to be wound down and Separate core operating value from non-operating or excess assets." +
        "\nBalance: " + assets.totalBalanceFormatted +
        "\nAdjustments: " + assets.totalAdjustmentsFormatted +
        "\nAdjusted Value: " + assets.totalAdjustedValueFormatted +
        // "\nLiquidation Percent: " + assets.totalLiquidationFormatted +
        // "\nLiquidation Value: " + assets.totalLiquidationValueFormatted +
        // "\nExcess/Non-Operating: " + assets.totalExcessOrNonOperatingFormatted +
        "\nThese are the company's total liability data." +
        "\nBalance: " + liabilities.totalBalanceFormatted +
        "\nAdjustments: " + liabilities.totalAdjustmentsFormatted +
        "\nAdjusted Value: " + liabilities.totalAdjustedValueFormatted +
        // "\nLiquidation Percent: " + liabilities.totalLiquidationFormatted +
        // "\nLiquidation Value: " + liabilities.totalLiquidationValueFormatted +
        // "\nExcess/Non-Operating: " + liabilities.totalExcessOrNonOperatingFormatted +
        "\nThese are the company's total equity data." +
        "\nBalance: " + equity.totalBalanceFormatted +
        "\nAdjustments: " + equity.totalAdjustmentsFormatted +
        "\nAdjusted Value: " + equity.totalAdjustedValueFormatted +
        // "\nLiquidation Percent: " + equity.totalLiquidationFormatted +
        // "\nLiquidation Value: " + equity.totalLiquidationValueFormatted +
        // "\nExcess/Non-Operating: " + equity.totalExcessOrNonOperatingFormatted +
        "\nPlease analyze this company's situation."

      const response = await apiGetGPTNoteGeneration(payload);
      return response;
    } catch (error) {
      throw error
    }
  }

  static async fetchGPTSearchRate(payload) {
    let response;
    try {
      for(let i = 0; i < 5; i++) {
        response = await apiGetGPTSearchRate(payload);
        if(Number(response) !== NaN) break;
      }
      return response;
    } catch (error) {
      throw error
    }
  }

  static async fetchGPTSearchCompany(payload) {
    try {
      const response = await apiGetGPTSearchCompany(payload);
      return response;
    } catch (error) {
      throw error
    }
  }

  static async fetchGPTSearchReport(payload) {
    try {
      const response = await apiGetGPTSearchReport(payload);
      return response.replace(/\*\*/g, '');
    } catch (error) {
      throw error
    }
  }

  static async fetchCompanyBalanceSheet({ companyId }, queryParams= {
    startMonth: null,
    endMonth: null,
  }) {
    try {
      const payload = { companyId, startMonth: queryParams.startMonth, endMonth: queryParams.endMonth }

      { //QBO data process
        const response = await apiGetCompanyBalanceSheet(payload);
        const decendantData = new Date(response[0].date) < new Date(response[response.length - 1].date) ? response.reverse() : response;
        return decendantData.map((report) => {
          let currentAssetsItems = []
          let fixedAssetsItems = []
          let currentLiabilitiesItems = []
          let longTermLiabilityItems = []
          let equityItems = []
          report.assets.items[0].items.forEach((item) => {
            currentAssetsItems.push(new FinancialAccount({
              accountId: item.accountId,
              name: item.name,
              value: item.value,
              category: selectCategory(item.name)
            }))
          })
          report.assets.items[1].items.forEach((item) => {
            fixedAssetsItems.push(new FinancialAccount({
              accountId: item.accountId,
              name: item.name,
              value: item.value,
              category: selectCategory(item.name)
            }))
          })
          report.liabilities.items[0].items.forEach((item) => {
            currentLiabilitiesItems.push(new FinancialAccount({
              accountId: item.accountId,
              name: item.name,
              value: item.value,
              category: selectCategory(item.name)
            }))
          })
          report.liabilities.items[1].items.forEach((item) => {
            longTermLiabilityItems.push(new FinancialAccount({
              accountId: item.accountId,
              name: item.name,
              value: item.value,
              category: selectCategory(item.name)
            }))
          })
          report.equity.items.forEach((item) => {
            equityItems.push(new FinancialAccount({
              accountId: item.accountId,
              name: item.name,
              value: item.value,
              category: selectCategory(item.name)
            }))
          })

          return new BalanceSheet({
            date: report.date,
            fromDateReport: report.fromDateReport,
            toDateReport: report.toDateReport,
            assets : [
              new FinancialAccount({
                name: report.assets.items[0].name,
                value: report.assets.items[0].value,
                items: currentAssetsItems
              }),
              new FinancialAccount({
                name: report.assets.items[1].name,
                value: report.assets.items[1].value,
                items: fixedAssetsItems
              }),
            ],
            liabilities : [
              new FinancialAccount({
                name: report.liabilities.items[0].name,
                value: report.liabilities.items[0].value,
                items: currentLiabilitiesItems
              }),
              new FinancialAccount({
                name: report.liabilities.items[1].name,
                value: report.liabilities.items[1].value,
                items: longTermLiabilityItems
              }),
            ],
            equity: equityItems,
          })
        });
      }
    } catch (error) {
      throw error
    }
  }

  static async fetchCompanyProfitAndLoss({ companyId }, queryParams = {
    startMonth: null,
    endMonth: null,
  }) {
    try {
      const payload = { companyId, startMonth: queryParams.startMonth, endMonth: queryParams.endMonth }

      { //QBO data process
        const response = await apiGetCompanyProfitLoss(payload);
        return response.map((report) => {
          let costOfSalesItems = []
          let expensesItems = []
          let incomeItems = []
          let otherExpensesItems = []
          let otherIncomeItems = []

          report.costOfSales.items.forEach((item) => {
            costOfSalesItems.push(new FinancialAccount({
              accountId: item.accountId,
              name: item.name,
              value: item.value,
              category: selectCategory(item.name)
            }))
          })
          report.expenses.items.forEach((item) => {
            expensesItems.push(new FinancialAccount({
              accountId: item.accountId,
              name: item.name,
              value: item.value,
              category: selectCategory(item.name)
            }))
          })
          report.income.items.forEach((item) => {
            incomeItems.push(new FinancialAccount({
              accountId: item.accountId,
              name: item.name,
              value: item.value,
              category: selectCategory(item.name)
            }))
          })
          report.otherExpenses.items.forEach((item) => {
            otherExpensesItems.push(new FinancialAccount({
              accountId: item.accountId,
              name: item.name,
              value: item.value,
              category: selectCategory(item.name)
            }))
          })
          report.otherIncome.items.forEach((item) => {
            otherIncomeItems.push(new FinancialAccount({
              accountId: item.accountId,
              name: item.name,
              value: item.value,
              category: selectCategory(item.name)
            }))
          })
  
          return new ProfitAndLoss({
            // companyId: report.metadata.businessId,
            fromDateReport: report.fromDateReport,
            toDateReport: report.toDateReport,
            costOfSales: new FinancialAccount({
              name: report.costOfSales.name,
              value: report.costOfSales.value,
              items: costOfSalesItems
            }),
            expenses: new FinancialAccount({
              name: report.expenses.name,
              value: report.expenses.value,
              items: expensesItems
            }),
            income: new FinancialAccount({
              name: report.income.name,
              value: report.income.value,
              items: incomeItems
            }),
            otherExpenses: new FinancialAccount({
              name: report.otherExpenses.name,
              value: report.otherExpenses.value,
              items: otherExpensesItems
            }),
            otherIncome: new FinancialAccount({
              name: report.otherIncome.name,
              value: report.otherIncome.value,
              items: otherIncomeItems
            }),
          })
        });
      }
    } catch (error) {
      console.log(error)
      throw error
    }
  }

  static async fetchProjectList(payload) {
    try {
      const response = await apiGetProjectList(payload);
      return response;
    } catch (error) {
      throw error
    }
  }

  static async fetchProjectData(payload) {
    try {
      const response = await apiGetProjectData(payload);
      return response;
    } catch (error) {
      throw error
    }
  }

  static async deleteProjectData(payload) {
    try {
      await apiDeleteProjectData(payload);
    } catch (error) {
      throw error
    }
  }

  static async saveProjectData(state = store.getState(), updateType = "FULL") {
    let payload = _.cloneDeep(state);   //it doesn't affect real state.
    payload.userId = payload.user?.uid; //for database handle
    payload.companyId = payload.appState?.companyData?.id; //for database handle

    if(updateType === "FULL") {
      if(Object.keys(payload.appState.projectDetail).length === 0) return;    //don't save when no model
      delete payload.hde;   //for old sessions
      delete payload.forecastRev;   //for old sessions
      delete payload.forecastDOE;   //for old sessions
      delete payload.analyst;   //for old sessions
      delete payload.user;
      delete payload.taxes;   //tax data is set globally and shouldn't be changed
      delete payload.reports;

      payload.financialRatios    //regenerate possible with only average employees data
        = { averageEmployees: payload.financialRatios.currentCompanyBizminerRatios?.averageEmployees };

      delete payload.financials.companyBalanceSheetsReports;   //for old sessions
      delete payload.financials.companyProfitAndLossReports;   //for old sessions
      delete payload.financials.currentCompanyMonthlyBalanceSheet;
      delete payload.financials.currentCompanyMonthlyProfitAndLoss;
      delete payload.financials.currentCompanyCashFlow;
      delete payload.financials.currentCompanyWorkingCapital;
    }

    try {
      const response = await apiSaveProjectData(payload);
      return response;
    } catch (error) {
      throw error
    }
  }
}
